import type { Lecture } from '@mathflat/domain/Lecture'
import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class LectureInfo extends DTO {
  id: number
  bigChapterName: string
  lectures: (Lecture & { bigChapterName: string; middleChapterName: string })[]

  constructor(data: Omit<LectureInfo, 'update' | 'updateExceptNullable' | 'toJS'>) {
    super()
    makeObservable(this, {
      id: observable,
      bigChapterName: observable,
      lectures: observable,
    })

    this.id = data.id
    this.bigChapterName = data.bigChapterName
    this.lectures = data.lectures
  }
}
